import { hfpInstrumentForRecord, hasStoredHfpInstrument } from './referralStatus';

/*
 * Whether the BTH clinicians reviewing a referral may see the child's
 * strengths and needs profile (TDI-483). The family's answer (TDI-482)
 * decides; no answer means no; a SEND withdrawal (TDI-479) ends access; and
 * there has to be a profile to share. Mirrors
 * profile_shared_with_clinicians in rms_functions/rms_profile_access.py,
 * which also keeps the hfpProfileShared flag the database rules read.
 */

const scored = (domains, generation) => {
  const entry = domains && domains[`hfp${generation.toUpperCase()}`];
  return Boolean(entry && entry.scoring);
};

/**
 * The record carries a profile: scoring on its own instrument when one is
 * stored (TDI-414), else on any generation, which is what the profile pages
 * decide to show for records that predate the setting.
 */
export function hfpProfileExists(patient) {
  if (!patient) return false;
  const domains = patient.domains || {};
  if (hasStoredHfpInstrument(patient)) return scored(domains, hfpInstrumentForRecord(patient));
  return ['v3', 'v2', 'v4'].some((generation) => scored(domains, generation));
}

export function senConsentWithdrawn(patient) {
  const sen = (patient && patient.senPathway) || {};
  return sen.status === 'stopped' && sen.stopReason === 'consent_withdrawn';
}

export function profileSharedWithClinicians(patient) {
  if (!patient) return false;
  const sharing = (patient.referralPathway || {}).profileSharing || {};
  if (sharing.answer !== 'yes') return false;
  if (senConsentWithdrawn(patient)) return false;
  return hfpProfileExists(patient);
}

/**
 * The family said yes and has not taken it back, but there is no profile yet
 * because the forms are not all done. Clinician screens show the pending
 * state here: the not-shared line would be untrue.
 */
export function profileAwaitingCompletion(patient) {
  if (!patient) return false;
  const sharing = (patient.referralPathway || {}).profileSharing || {};
  if (sharing.answer !== 'yes') return false;
  if (senConsentWithdrawn(patient)) return false;
  return !hfpProfileExists(patient);
}

/** The one neutral line clinician screens show instead of the profile. */
export const PROFILE_NOT_SHARED_LINE =
  'The family has not shared the strengths and needs profile with the clinical team.';
